import React from 'react';

// LR-498: the tiny no-axis sparkline shown on each Cash Pool counterparty row in the left
// rail — a glanceable trend of recent running balances. Same polyline geometry as the
// design handoff's `spark()` helper (viewBox 0 0 96 30), rendered ~62×22 and stretched to
// fit (preserveAspectRatio="none"). Since LR-542 (variant A) the caller passes a constant
// neutral stroke — the billing-signed balance carries no sign colour.

export interface MiniSparklineProps {
  /** Recent values oldest → newest. A single value renders a flat line. */
  values: number[];
  /** Stroke colour (the caller owns the palette; currently the constant SPARK_NEUTRAL). */
  color: string;
  className?: string;
}

export const MiniSparkline: React.FC<MiniSparklineProps> = ({ values, color, className }) => {
  if (values.length === 0) return null;
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;
  const n = values.length;
  const points = values
    .map((v, i) => {
      const x = n === 1 ? 0 : (i / (n - 1)) * 96;
      const y = 28 - ((v - min) / range) * 26;
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(' ');

  return (
    <svg
      width={62}
      height={22}
      viewBox="0 0 96 30"
      preserveAspectRatio="none"
      className={className}
      style={{ opacity: 0.85 }}
      aria-hidden
    >
      <polyline
        points={points}
        fill="none"
        stroke={color}
        strokeWidth={2}
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
};
